/** Type aliases, so they carry the implicit index signature `JSONContent` requires. */
export type TipTapNode = {
  type?: string;
  text?: string;
  content?: TipTapNode[];
};

export type TipTapDocument = {
  type: 'doc';
  content: TipTapNode[];
};

/** Nodes whose children run together on one line. */
const INLINE_CONTAINER_TYPES = new Set([
  'blockquote',
  'codeBlock',
  'heading',
  'listItem',
  'paragraph',
  'tableRow',
]);

const nodeToText = (node: TipTapNode): string => {
  if (node.type === 'text') {
    return node.text ?? '';
  }

  if (node.type === 'hardBreak') {
    return '\n';
  }

  const children = (node.content ?? []).map(nodeToText);

  return INLINE_CONTAINER_TYPES.has(node.type ?? '') ? children.join('') : children.join('\n');
};

/** One line per block; marks, images and maths are dropped rather than encoded. */
export const tipTapToPlainText = (document?: { content?: TipTapNode[] }): string =>
  (document?.content ?? [])
    .map(nodeToText)
    .filter(line => line.trim().length > 0)
    .join('\n')
    .trim();

/** Plain paragraphs as the TipTap document a comment field can render. */
export const paragraphsToTipTap = (paragraphs: string[]): TipTapDocument => ({
  type: 'doc',
  content: paragraphs.map(text => ({
    type: 'paragraph',
    // An empty text node is not valid TipTap content
    ...(text.length > 0 ? { content: [{ type: 'text', text }] } : {}),
  })),
});
